jQuery( function ($) {

  var ShareBasketHandler = function() {
    $('#share-basket-form').on('submit', { shareBasketHandler: this }, this.submitShareBasket);
    $('#share-basket-merge-form').on('submit', { shareBasketHandler: this }, this.submitShareBasketMerge);
    $('#share-basket-overwrite-form').on('submit', { shareBasketHandler: this }, this.submitShareBasketOverwrite);
  }

  ShareBasketHandler.prototype.submitShareBasket = function(e) {
    e.preventDefault();

    let form_data = $("#share-basket-form").serializeArray();
    form_data.push({
      name: 'nonce',
      value: share_cart_ajax_var.nonce
    });
    $.ajax({
      url: share_cart_ajax_var.url,
      data: $.param(form_data), // form data
      type: 'POST', // POST
      beforeSend: function (xhr) {
        $(".c-form--share-basket").addClass("hidden");
        $(".c-form--share-basket__spinner").removeClass("hidden");
      },
      success: function (data) {
        $(".c-form--share-basket__spinner").addClass("hidden");
        let results = JSON.parse(data);
        if (results.type == "success") {
          $(".share-basket-message-text").html('Thanks, an email containing a link to the basket has now been sent.');
          $(".share-basket-message-image").attr('src','/app/themes/penkethstore/dist/images/success-icon.svg');
        } else {
          $(".share-basket-message-image").attr('src','/app/themes/penkethstore/dist/images/fail-icon.svg');
          if (!results.validation) {
            $(".share-basket-message-text").html('The email address used is not valid.');
          } else {
            $(".share-basket-message-text").html('An error occurred.');
          }
        }
        $(".message.share-basket").removeClass("hidden");
      },
      error: function (XMLHttpRequest, status, errorMessage) {
        $(".c-form--share-basket__spinner").addClass("hidden");
        //console.log(status + ":" + errorMessage);
        $(".share-basket-message-text").html('An error occurred.');
        $(".share-basket-message-image").attr('src','/app/themes/penkethstore/dist/images/fail-icon.svg');
        $(".message.share-basket").removeClass("hidden");
      }
    });
  }

  ShareBasketHandler.prototype.submitShareBasketMerge = function(e) {
    e.preventDefault();
    var current_url = window.location.href;
    var url = new URL(current_url);
    url.searchParams.append('merge', true);
    window.location.href = url.href;
  };

  ShareBasketHandler.prototype.submitShareBasketOverwrite = function(e) {
    e.preventDefault();
    var current_url = window.location.href;
    var url = new URL(current_url);
    url.searchParams.append('overwrite', true);
    window.location.href = url.href;
  };

  new ShareBasketHandler();
});
